<div class="container-fluid" style="background-color:rgb(242,242,242) !important;height:75px!important;margin-bottom:1px!important;">
  <div class="row">
    <div class="col-md-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
    <div class="col-6"></div>
    <div class="col-6">
      <div class="row">
        <div style="width: 70px;height: 70px;"  *ngIf="screen=='statement'" class="col-2">
          <div class="" title="Cancel" style="margin: 0px auto;" rel="tooltip" data-placement="top">
            <div class="app-cancel" (click)=" cancelStatement()"></div>
          </div>
          <!-- <div class="lbl-app" style="margin: 1px auto;">
            <span>Cancel</span>
          </div> -->
        </div>
        <!-- <div style="width: 70px;height: 70px;" *ngIf="screen=='statement'" class="col-2">
          <div class="" title="Print Statement" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                <div id="print-statement"  (click)="printStatement()"></div>
          </div>
        </div> -->
        <div style="width: 70px;height: 70px;" *ngIf="screen=='statement'" class="col-2">
          <div class="" title="Download Statement" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                <div id="download-statement"  (click)="downloadStatement()"></div>
          </div>
        </div>
        <div style="width: 70px;height: 70px;"  *ngIf="screen=='statement'" class="col-2">
          <div class="" title="Email Statement" style="margin: 0px auto;" rel="tooltip" data-placement="top">
           <div id="email-statement"   (click)="emailStatement()"></div>
         </div>
        </div>
        <div style="width: 70px;height: 70px;"  *ngIf="screen=='invoice'" class="col-2">
          <div class="" title="Cancel" style="margin: 0px auto;" rel="tooltip" data-placement="top">
            <div class="app-cancel" (click)="cancelInvoice()"></div>
          </div>
         </div>
        <div style="width: 70px;height: 70px;"  *ngIf="screen=='invoice'" class="col-2">
          <div class="" title="Download Invoice" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                <div id="download-statement"  (click)="downloadInvoice()"></div>
          </div>
        </div>
        <div style="width: 70px;height: 70px;"  *ngIf="screen=='invoice'" class="col-2">
          <div class="" title="Email Invoice" style="margin: 0px auto;" rel="tooltip" data-placement="top">
           <div id="email-statement"  (click)="emailInvoice()"></div>
         </div>
        </div>
      </div>
    </div>
  </div>
</div>

